module.exports = __webpack_public_path__ + "static/img/hot6.148f7f3.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/xiangyun/hot6.jpg
// module id = TeZr
// module chunks = 1